import { Sparkles } from "lucide-react";
import AnimatedSection from "@/utils/AnimatedSection";

const PlatformIntro = () => {
  const stats = [
    { value: "5", label: "Health Dimensions Covered" },
    { value: "<10 min", label: "Per Complete Assessment" },
    { value: "100%", label: "Non-Invasive" },
    { value: "Real-Time", label: "Personalized Reports" },
  ];

  return (
    <section className="py-20 md:py-28 relative overflow-hidden platform-intro-section" data-testid="platform-intro-section">
      <div className="absolute inset-0 bg-gradient-to-br from-[#1a1a2e] via-[#16213e] to-[#0f3460]" />
      <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-[#4ECDC4]/10 rounded-full blur-[100px]" />
      <div className="absolute bottom-0 left-0 w-[300px] h-[300px] bg-[#A855F7]/10 rounded-full blur-[80px]" />
      
      <div className="max-w-6xl mx-auto px-6 relative z-10">
        <AnimatedSection>
          <div className="text-center max-w-3xl mx-auto mb-16">
            <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 border border-white/10 text-[#4ECDC4] text-sm font-semibold mb-6 uppercase tracking-wider">
              <Sparkles className="w-4 h-4" />
              Introducing tots360
            </span>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-white mb-6 leading-tight">
              One Platform. Five Dimensions of Child Health.
            </h2>
            <p className="text-white/70 text-lg md:text-xl leading-relaxed">
              tots360 is our AI-powered health intelligence platform that assesses your child across five critical health dimensions — in under 10 minutes, completely non-invasive.
            </p>
          </div>
        </AnimatedSection>

        <AnimatedSection delay={0.2}>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
            {stats.map((stat, i) => (
              <div key={i} className="relative group" data-testid={`platform-stat-${i}`}>
                <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 md:p-8 text-center hover:bg-white/10 transition-all duration-300 h-full">
                  <p className="font-display text-4xl md:text-5xl text-white mb-2">{stat.value}</p>
                  <p className="text-white/60 text-sm md:text-base leading-snug">{stat.label}</p>
                </div>
                <div className={`absolute top-0 left-1/2 -translate-x-1/2 w-12 h-1 rounded-full ${
                  i === 0 ? 'bg-[#4ECDC4]' : i === 1 ? 'bg-[#FFE66D]' : i === 2 ? 'bg-[#FF6B6B]' : 'bg-[#A855F7]'
                }`} />
              </div>
            ))}
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default PlatformIntro;
